import _ from '/home/ps/root'
// import React from 'react'
import action from '../action'
import { Toast, toast } from '../component/master/toast'
import { Ref, Blank, setBlank, getBlank, isElementVisible, MASTER, STAGE, stage, equal, getLoginRow, getConfig, eId, audio, promise, vendorConfig, image, Route, Param, goOffline, copy, cookies, cache, session } from '../global'
var cookie = cookies()
const singleton = {}
export const ID = 'IO'
Ref[ID] = {}
const _io_ = Ref[ID]
// const Field = Ref.field
// const Row = Ref.row
// const Table = Ref.table

const modified = r => {
  const local = {}
  const net = {}
if (!r.lang) debugger
  // if (!r.lang) return
  // const lang = r.lang
  const lang = r.lang || _.EN
  Object.keys(r.buffer || {}).reduce((hosts, host) => {
    if (!net[host]) net[host] = {}
    if (!local[host]) local[host] = {}
    Object.keys(r.buffer[host]).reduce((vs, v) => {
if (!v) debugger
      // if (v == 'callback') return vs
      if (!net[host][v]) net[host][v] = {}
      if (!local[host][v]) local[host][v] = {}
      Object.keys(r.buffer[host][v]).reduce((dbs, db) => {
if (!db) debugger
        if (_.VERB_.includes(db)) {
          const printer = cache(`${lang}${v}${db}`)
          if (printer) {
            if (!local[host][v][db]) local[host][v][db] = printer
          } else if (!net[host][v][db]) net[host][v][db] = r.buffer[host][v][db]
          return dbs
        }
if (v=='login') debugger
        if (!net[host][v][db]) net[host][v][db] = {}
        if (!local[host][v][db]) local[host][v][db] = {}
        const vcache = cache(`${lang}${db}${v}`)
        var offset = 0, print = _.PUB, meta = `${offset}${print}`
        Object.keys(r.buffer[host][v][db]).reduce((keys, key) => {
if (!key) debugger
          const need = r.buffer[host][v][db][key]
if (typeof need == 'undefined') debugger
          if (!vcache) {
            if (!net[host][v][db][key]) net[host][v][db][key] = need
            return keys
          }
          // if (vcache.modified) net[v][db].modified = vcache.modified
          switch (key) {
            case 'offset':
            offset = need
            meta = `${offset}${print}`
            break

            case 'print':
            print = need
            meta = `${offset}${print}`
            break

            case 'default':
if (v=='q')debugger
            const medias = pk => {
              if (!_.FILE_.includes(v)) return
              const row = cache(`${lang}${db}${v}${pk}`)
              const files = JSON.parse(row.medias)
              const fpk = files.length && files[0]
              if (fpk) {
                const frow = cache(`${lang}${db}media${fpk}[]`)
                if (frow) {
                  if (!local[host].media) local[host].media = {}
                  if (!local[host].media[db]) local[host].media[db] = {}
                  if (!local[host].media[db][key]) local[host].media[db][key] = {}
                  if (!local[host].media[db][key][fpk]) local[host].media[db][key][fpk] = frow
                  if (!net[host].media) net[host].media = {}
                  if (!net[host].media[db]) net[host].media[db] = {}
                  if (!net[host].media[db].verify) net[host].media[db].verify = {}
                  if (!net[host].media[db].verify[fpk]) net[host].media[db].verify[fpk] = frow[1]
                }
              }
            }
            if (Object.keys(need).length==0) {
              if (vcache[meta]) {
                if (!local[host][v][db][key]) local[host][v][db][key] = {}
                if (vcache[print]) local[host][v][db][print] = vcache[print]
                local[host][v][db].offset = offset
                local[host][v][db].print = print
                if (vcache[meta]) local[host][v][db][meta] = vcache[meta]
                if (vcache.modified) net[host][v][db].modified = vcache.modified
                vcache[meta].reduce((pks, pk) => {
                  const row = cache(`${lang}${db}${v}${pk}[]`)
                  if (row) {
                    local[host][v][db].default[pk] = row
                    if (!net[host][v][db].verify) net[host][v][db].verify = {}
                    net[host][v][db].verify[pk] = row[1]
                    medias(pk)
                  } else {debugger // should not reach here
                    if (!net[host][v][db][key]) net[host][v][db][key] = {}
                    net[host][v][db][key][pk] = 'find'
                  }
                  return pks
                }, {})
              } else {
               net[host][v][db].offset = offset
               net[host][v][db].print = print
               net[host][v][db][key] = need
              }
            } else { // if (need.length==0)
              Object.keys(need).forEach(pk => {
                const row = cache(`${lang}${db}${v}${pk}[]`)
                if (row) { // tested
                  if (!local[host][v][db][key]) local[host][v][db][key] = {}
                  if (!local[host][v][db][key][pk]) local[host][v][db][key][pk] = row
                  // if (row!='find' && v!='login' && !window.opener) { // tested
                  if (row!='find' && !window.opener) { // tested
                    if (!net[host][v][db].verify) net[host][v][db].verify = {}
                    if (!net[host][v][db].verify[pk]) net[host][v][db].verify[pk] = row[1]
                  }
                  medias(pk)
                }
                if (!row || row=='find') { // tested
                  if (!net[host][v][db][key]) net[host][v][db][key] = {}
                  net[host][v][db][key][pk] = 'find'
                }
              })
            }
            break
            case 'album':
            const n = `\`album\`='${need}'`
            if (vcache[need]) {
              local[host][v][db][need] = vcache[need]
              local[host][v][db][k] = need
              vcache[need].default.forEach(pk => {
                const row = cache(`${lang}${db}${v}${pk}[]`)
                if (row) {
                  if (!local[host][v][db].default) local[host][v][db].default = {}
                  local[host][v][db].default[pk] = row
                  if (!net[host][v][db].verify) net[host][v][db].verify = {}
                  net[host][v][db].verify[pk] = row[1]
                } else {
                  if (!net[host][v][db].default) net[host][v][db].default = {}
                  net[host][v][db].default[pk] = 'find'
                }
              })
            } else net[host][v][db][key] = need
            break
            case 'count':
            switch (need) {
              case _.PRI:
              case _.PUB:
              if (vcache[need]) local[host][v][db][need] = vcache[need]
              else net[host][v][db][key] = need
            }
            break
            case 'all': debugger; break // never implemented
            case 'where':
// if (v=='purchase')debugger;
            switch (need) {
              case 'valid':
              const valid = vcache.valid
              if (valid) {
                if (!local[host][v][db][key]) local[host][v][db][key] = 'valid'
                if (!local[host][v][db].valid) local[host][v][db].valid = valid
                if (!local[host][v][db][valid]) local[host][v][db][valid] = vcache[valid]
                if (!local[host][v][db].default) local[host][v][db].default = {}
                // if (!net[v][db].verify)  net[v][db].verify = {}
                vcache[need].forEach(pk => {
                  const row = cache(`${lang}${db}${v}${pk}[]`)
                  if (row) {
                    local[host][v][db].default[pk] = row
                    // net[v][db].verify[pk] = row[1]
                  } else {
                    if (!net[host][v][db].default) net[host][v][db].default = {}
                    net[host][v][db].default[pk] = 'find'
                    debugger
                  }
                })
              } else if (!net[host][v][db][key]) net[host][v][db][key] = need
              break
              default: if (!net[host][v][db][key]) net[host][v][db][key] = need
            } // switch need where
          } // switch key
          if (key!='default' && Object.keys(net[host][v][db][key] || {}).length==0) delete(net[host][v][db][key])
          if (Object.keys(local[host][v][db][key] || {}).length==0) delete(local[host][v][db][key])
          return keys
        }, {}) // key
        if (Object.keys(net[host][v][db] || {}).length==0) delete(net[host][v][db])
        if (Object.keys(local[host][v][db] || {}).length==0) delete(local[host][v][db])
        return dbs
      }, {}) // db
      if (Object.keys(net[host][v] || {}).length==0) delete(net[host][v])
      if (Object.keys(local[host][v] || {}).length==0) delete(local[host][v])
      return vs
    }, {}) // v
    if (Object.keys(net[host] || {}).length==0) delete(net[host])
    if (Object.keys(local[host] || {}).length==0) delete(local[host])
    return hosts
  }, {}) // host
  return {local, net}
}
export const tcp2 = ({request, shard=cookie.p, credential=true, url=`https://${shard}.${_.DOMAIN}/fec/request${__DEV__ ? '.dev':''}.php`, single=true, callback, parking=true}) => tcp(request, shard, credential, url, callback, parking, single)
export const tcp = (r, shard=cookie.p, credential=true, url=`https://${shard}.${_.DOMAIN}/fec/request${__DEV__ ? '.dev':''}.php`, callback, parking=true, single=true) => {
  const j = JSON.stringify(r)
  if (single && singleton[j]) return console.log({ID, 'singleton[j]': singleton[j], r});
  singleton[j] = (new Date()).getTime()
  r.single = singleton[j]
  switch (r.type) {
    case 'io':
    url=`https://${shard}.${_.DOMAIN}/fec/io${__DEV__ ? '.dev' : ''}.php`
    break
    case 'init':
    case 'reset':
    case 'request':
    case 'p':
    case 'notice':
    case 'online':
    url=`https://${shard}.${_.DOMAIN}/fec/type${__DEV__ ? '.dev' : ''}.php`
    break
  }
  console.log({ID, r, shard, credential, url, callback, parking})
  switch (r.type) {
    // case 'modified':
    case 'init':
    if (cache(`init${r.lang}`)) break
    case 'reset':
    case 'request':
    case 'io':
    case 'p':
    case 'notice':
    case 'online':
    case 'table':
    network(r, shard, credential, url, callback, parking)
    break

    default:
    const {local, net} = modified(r)
    if (Object.keys(local).length) {
      const l = copy(r)
      l.buffer = local
      l.debug = 'loop'
      console.log({[ID]: 'tcp', local})
if (r.vendor && typeof r.vendor=='undefined') debugger
      loop(l, callback, parking)
//IO[`${_.VIEW}${_.MASTER}`].message({cart: 'loop', l})
    }
    if (Object.keys(net).length) {
      const n = copy(r)
      n.buffer = net
      // const j = JSON.stringify(n)
      // if (single && singleton[j]) return console.log(ID, `singleton tcp`, singleton[j], n);
      // singleton[j] = (new Date()).getTime()
      // n.t = singleton[j]
      // n.single = r.single
      console.log({[ID]: 'tcp', net})
      network(n, shard, credential, url, callback, parking)
      // IO.Task.push({callback: network, arg: [IO.Net[shard], shard], delay: 3})
//IO[`${_.VIEW}${_.MASTER}`].message({cart: 'net', n})
    } // if (Object.keys(net).length) {
  }
}
// const network = (n, shard) => {
//   if (!IO.Net[shard]) IO.Net[shard] = {}
//   Object.keys(n).forEach(i => {
//     if (!IO.Net[shard][i]) IO.Net[shard][i] = {}
//     switch (i) {
//       case _.BUFFER:
//       Object.keys(n[i]).reduce((vs, v)=>{
//         if (!IO.Net[shard][i][v]) IO.Net[shard][i][v] = {}
//         Object.keys(n.buffer[v]).reduce((dbs, db)=>{
//           if (!IO.Net[shard][i][v][db]) IO.Net[shard][i][v][db] = {}
//           Object.keys(n.buffer[v][db]).reduce((keys, k)=>{
//             if (_.VERB_.includes(db)) {
//               IO.Net[shard][i][v][db] = n[i][v][db]
//               return keys
//             }
//             switch (k) {
//               case _.WHERE:debugger;break
//               case _.OFFSET:debugger;break
//               case _.PRINT_:debugger;break
//               case 'count':
//               case 'default':
//               IO.Net[shard][i][v][db][k]=n[i][v][db][k]
//             }
//           }, {})
//         }, {})
//       }, {})
//       break
//       case 'type':debugger
//       default: IO.Net[shard][i] = n[i]
//     }
//   })
//   network2(n, shard)
// }
// export const network = (r, shard=_.ROOT, credential=false, callback, url = `https://${shard}.${_.DOMAIN}/fec/request.php`) => {
export const network = (r, shard=cookie.p, credential=true, url, callback, parking=true) => {
  // if (__DEV__) {
    // const debug = [
    //   cookie.username,
    //   `__DEV__${_.RTL_.join('')}__DEV__${_.DEV_PATH}__DEV__${_.LTR_.join('')}__DEV__`,
    // ]
    const debug = [cookie.username]
    if (__DEV__) debug.push(`__DEV__${_.RTL_.join('')}__DEV__${_.DEV_PATH}__DEV__${_.LTR_.join('')}__DEV__`)
    const err = new Error()
    const stack = err.stack.split('\n')
    stack.forEach((line, i) => {
      // if (__DEV__) {
        if (i>2 && line.includes('./src/')) debug.push(line.trim())
      // } else if (i>4) debug.push(line.trim())
    })
    r.debug = debug
  // }
  const xhr = new XMLHttpRequest()
  const fd = new FormData()
  xhr.onabort = e => {debugger}
  xhr.onerror = e => {debugger}
  xhr.onload = e => {}
  xhr.onloadend = e => {}
  xhr.onloadstart = e => {}
  xhr.onprogress = e => {
    if (e.lengthComputable) {
      var percentComplete = (e.loaded / e.total) * 100
      console.log(ID, 'xhrProgress computable', percentComplete, e);
    } else {
      // Unable to compute progress information since the total size is unknown
      console.log(ID, 'xhrProgress ', e);
    }
  }
  xhr.onreadystatechange = e => {
    if(__DEV__ && xhr.readyState == xhr.HEADERS_RECEIVED) {
      var headers = xhr.getAllResponseHeaders()
      var arr = headers.trim().split(/[\r\n]+/) // Convert the header string into an array of individual headers
      var headerMap = {} // Create a map of header names to values
      arr.forEach(function (line) {
        var parts = line.split(': ')
        var header = parts.shift()
        var value = parts.join(': ')
        headerMap[header] = value;
      })
    }
    if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
      if (xhr.response.length > 0) {
        var payload
        try {
          payload = JSON.parse(xhr.response)
          console.log(ID, `try xhr.response.length ${xhr.response.length}`, payload)
        }
        catch (e) {
          payload = xhr.response
          console.log(ID, `catch preview`, payload)
        }
        const single = Object.keys(singleton).find(key => singleton[key] === payload.single)
        if (single) {
          console.log({[ID]: 'clear', single})
          delete(singleton[single])
        }
        if (parking) dispatch(payload, callback)
        else if (callback) callback(payload)
        // else dispatch(payload)
        // if (parking) dispatch(payload, callback)
      } else console.log(ID, `xhr.response.length ${xhr.response.length}`)
    }
  }
  fd.append('request', JSON.stringify(r))
  switch(r.type) {
    case 'io':
    fd.append('io', r.io)
    fd.append('to', r.to)
  }
  if (r.v=='media') {
    const files = r.request.selectmedia
    files.forEach((f, i) => {
      const {src, title, file} = f
      fd.append('media[]', file)
      console.log({ID, src, title, i, file})
    })
  }
  for (var pair of fd.entries()) {
    console.log(ID, pair[0], ' --> ', pair[1])
  }
  console.log(ID, `tcp network`, {url, credential, shard, r})
  xhr.open('post', url)
  if (credential) xhr.withCredentials = credential;
  xhr.send(fd)
}
export const localhost = r => {
  console.log(ID, `dispatch localhost ${r.type} response`, {r})//, IO.store.getState()[_.MASTER])
  // setTimeout(() => IO.dispatch(action[`${r.type}response`](r)), 1)
  Ref.store.dispatch(action[`${r.type}response`](r))
}
export const setPurchase = r => localhost( { ...r, type: 'purchasee' } )
export const setP = r => localhost({...r, type: 'p'})
export const setPark = (r, callback) => localhost({...r, type: 'park', callback})
export const act = r => {
  console.log(ID, `act`, {r})
  setTimeout(() => Ref.store.dispatch(r), 1)
}
export const tact = (type, data=[]) => {
  console.log(ID, `tact`, {type, data})
  act(action[type](...data))
}
export const loop = (r, callback) => {
  console.log(ID, `dispatch loop`, r)
  setTimeout(() => dispatch(r, callback), 1)
}
export const go = (method=Ref.history.push, route=[], param=Param(), callback, content=[], response=[]) => {
  const {master, connected, visible} = MASTER()
  // const _uris = Uris()
  const _param = param.length ? `?${param.join('&')}` : ''
  const url = `/${route.join('/')}${_param}`
  const goingOnline = route.length>1 && route[1]=='online'
  console.log(ID, 'go', {method: method.name, url, connected})
  if (connected && !goingOnline) {
    if (visible) audio('user')
    const _toast = {
      content: content.length ? content : [`${master.go.i} ${master.offline.i} ?`],
    }
    if (response.length) _toast.response = response
    Toast({..._toast, callback: r => {
      if (r) {
        if (connected && !goingOnline) {
          console.log({ID, Ref})
          if (__DEV__) {
            Ref.socket.connected = false
            Ref.socket.disconnected = true
          } else if (!Ref.socket.disconnected) Ref.socket.disconnect()
          Ref.status.setState({init: false})
        }
        if (!window.opener) {
          // Fields[IO.viewmaster.state.vid]={}
          // Ref.field[]
          // IO.row={}
          Ref.row = {}
          // Object.keys()
        }
        method(url)
      }
      if (callback) callback(r)
    }})
  } else {
    if (!window.opener) {
      // const db = IO.viewmaster?.state?.vid
      const db = Ref.viewmaster?.state?.vid
      // if (db) Fields[db]={}
      /////////////////// ???????????????????????????????????????? below
      // IO.row={}
    }
    method(url)
  }
}
var indexCart=0, CART={}
const cartRemove = ({v, pk, memo}) => {
  delete(CART[v][pk][memo])
  if (Object.keys(CART[v][pk]).length==0) delete(CART[v][pk])
  if (Object.keys(CART[v]).length==0) delete(CART[v])
}
export const cartMerge = ({json, reset=false, pid, onChange=false, user={}}) => {
  if (reset) {
    // Object.keys(CART).every(k => delete(CART[k]))
    CART = {}
    indexCart = 0
  }
  const neverStale = isNaN(user.id)
  console.log({ID, Ref, CART, indexCart, json, reset, pid, onChange})
  JSON.parse(json).reduce((acc, [_pk, _stock, _price, v='item', memo='', _stale=false]) => {
if (isNaN(_stock) || isNaN(_price)) debugger
    const memoChange = typeof onChange=='string' && onChange!='stock'
    const stock = Number(_stock)
    const pk = Number(_pk)
    const price = Number(_price).toFixed(2)
    const stale = neverStale ? false : _stale
    if (stock==0 && reset) {
      if (CART[v]?.[pk]?.[memo]) return cartRemove({v, pk, memo})
      else return
    }
    if (stock==-1) {debugger;return cartRemove({v, pk, memo})}
    if (!CART[v]) CART[v] = {}
    if (!CART[v][pk]) CART[v][pk] = {}
    if (memoChange) {
      const prev = CART[v][pk][onChange]
      delete(CART[v][pk][onChange])
      CART[v][pk][memo] = {
        ...prev,
        stock: CART[v][pk][memo] ? (CART[v][pk][memo].stock + stock) : stock,
        stale,
        memoChange,
      }
    } else if (!CART[v][pk][memo]) {
      CART[v][pk][memo] = {
        indexCart: indexCart++,
        price,
        stock,
        stale,
      }
    } else {
      Object.keys(CART[v][pk]).reduce((acc, m) => {
        if (m == memo) {
// if (onChange!='stock') debugger
          const s = CART[v][pk][m]
          CART[v][pk][m] = {
            ...s,
            stock: onChange=='stock' ? stock : stock + s.stock,
          }
        } else if (CART[v][pk][memo]) return
        else {
          CART[v][pk][m] = {
            indexCart: indexCart++,
            price,
            stock,
            stale,
          }
        }
      }, {})
    }
  }, [])
  const indexed = Object.keys(CART).reduce( (acc, v, i) => {
    Object.keys(CART[v]).forEach( pk => {
      Object.keys(CART[v][pk]).forEach( memo => {
        const { indexCart, price, stock, stale, memoChange = false } = CART[v][pk][memo]
        const kv = [pk, stock, price, v, memo]
        const _stale = stale && !neverStale
        if (_stale) kv.push(stale)
if (acc[indexCart]) debugger
        acc[indexCart] = kv
        if (!reset && stock>0) {
          var key = `${ pid } ${ v } ${ 'delete' } ${ pk }`
          promise(() => {
            const stockF = Ref.field[ `${ key } stock` ]
            if (!stockF) return true
            const memoF = Ref.field[ `${ key } memo` ]
            const s = { value: stock }
            if (_stale) {
              if (Ref.socket.connected) memoF.setField({ stale: memoChange ? stale : false })
              s.stale = stock > 1 ? stale : false
            }
            stockF.setField(s)
          })
        }
      })
    })
    return acc
  }, {})
  return Object.keys(indexed).sort().reduce((acc, i) => {
    acc.push(indexed[i])
    return acc
  }, [])
}
export const dispatch = (r, callback) => {
if (r.e) debugger // e => io
  const t = typeof r.debug
  console.log(ID, `dispatch tcp ${t == 'undefined' ? 'local or js' : (t=='object' ? 'network':r.debug)}`, copy(r))
  const { store: prop, p, park, lang, user, master, visible} = MASTER()
  const cartI = master?.cart.i, vendorI = master?.vendor.i, okI = master?.ok.i, lockI = master?.lock.i, orderI = master?.order.i, storeI = master?.store.i, openI = master?.open.i.l
  cookie = cookies()
  const { login, username, id: cid } = cookie
  const { vendor } = p
  const vid = vendor?.id
  const vendorname = vendor?.username
  // const interval = {}
  const Master=Ref.viewmaster, Table=Ref.table, Row=Ref.row, Field=Ref.field, User=Ref.user, Chat=Ref.chat, Online=Ref.online
  const data = r.data
  const remotePurchase = data?.purchase
  const modified = data?.modified
  const cart = data?.cart
  var npk = prop.new[vid]?.purchase
  const from = r.from
  const lock = from?.lock || false
  const fid = from?.id || vid
  const fpk = from?.pk || npk
  const shard = from?.p
  const name = from?.name || vendor?.name
  const vendorCfg = getConfig(park, lang, vid)
  const title = vendorCfg?.title || name
  const to = r.to
  const tid = to?.[0]
  const fromVendor = fid==vid
  // const owner = cid==vid
  const owner = login && cid==vid
  // const pid = from?.stage?.pk || fid || vid
  const pid = from?.stage?.pk || (owner ? fid : vid) // purchase db
  const ppk = from?.stage?.pk || (owner ? pid : npk) // purchase pk
  const localPurchase = park?.purchase?.[pid]?.default[ppk]
  const localCart = JSON.parse(localPurchase?.json || '[]')
  const remoteCart = JSON.parse(remotePurchase?.json || '[]')
  const mute = User?.[pid]?.mute
  const neverStale = !isNaN(user[pid]?.id)
  const vendorCache = owner ? null : Object.keys(STAGE).reduce((acc, id) => {
    if (STAGE[id].id==vid) return STAGE[id]
    return acc
  }, null)
  console.log({ID, STAGE, r, type: r.type, io: r.io, remotePurchase, fid, fpk, name, pid, ppk, npk, localPurchase, mute, neverStale, user, vendorCache})
  var purchasePk, files, file, filePk, pub, vcache, count, display, printer, upark, io
  var cfgRow, cfgId, response
  const updatePurchase = purchase => {
    var key = `${ pid } purchase default ${ ppk }`
    promise(() => {
      const tipF = Field[ `${ key } tip`]
      if (!tipF) return true
      const discountF = Field[ `${ key } discount`]
      // const stale = false
      if (purchase.tip != tipF.state.value) tipF.setField({ value: purchase.tip, stale: false })
      if (purchase.discount != discountF.state.value) discountF.setField({ value: purchase.discount, stale: false })
      JSON.parse(purchase.json).forEach(kv => {
        const [kpk, stock, price, v='item', memo=''] = kv
        var key = `${ pid } ${ v } delete ${ kpk }`
        promise(() => {
          const stockF = Field[ `${ key } stock`]
          if (!stockF) return true
          if (stock != stockF.state.value) stockF.setField({ value: stock, stale: false })
          const memoF = Field[ `${ key } memo`]
          if (memo != memoF.state.value) memoF.setField({ value: memo, stale: false, expand: memo.length })
if (stockF.props?.row?.setRow) debugger
if (stockF.props?.row?.setRow) stockF.props.row.setRow({ stale: false })
        })
      })
      // Row[pid].purchase[ppk].setRow({stale})
      // Row[`${ pid } purchase default ${ ppk }`].setRow({ stale: false })
    })
  }
  const confirmCart = purchase => {
    const cart = cartMerge({json: purchase.json, reset: true})
    purchase.json = JSON.stringify(cart)
    purchase.modified = Math.round(Date.now()/1000)
    const buff = {
      // debug: ID,
      type: 'io',
      lang,
      p: shard,
      io: 'cart',
      to: [fid],
      from: {
        id: cid,
        pk: owner ? ppk : npk,
        p: cookie.p,
        stage: from.stage,
        lock,
        confirm: true,
      },
      data: {
        purchase: purchase,
      },
    }
    if (Chat[pid]?.offline && Chat[pid]?.auto) {
      buff.data.chat = Object.keys(Chat[pid].chat).reduce((acc, id) => {
        const [text, sent] = Chat[pid].chat[id]
        if (!sent) acc.push({[id]: [text, cookie.p]})
        return acc
      }, [])
      Chat[pid].setChat(buff.data.chat)
    }
    console.log({tcp: 'confirmCart', owner, vid, from, buff, pid, ppk, npk, buff, shard})
    if (!from.confirm) tcp(buff, shard)
    updatePurchase(purchase)
    return purchase
  }
  const cleanCart = cart => cart.reduce((acc, [pk, stock, price, v, memo]) => {
    acc.push([pk, stock, price, v, memo])
    return acc
  }, [])
  const copyTotal = (from, to) => {
    if (!from) {
      debugger
      console.log({tcp: 1, from, to})
      return to
    }
    if (!to) {
      debugger
      console.log({tcp: 2, from, to})
      return from
    }
    to['subtotal'] = from['subtotal']
    to.total = from.total
    to.tax = from.tax
    to.tip = from.tip
    to.discount = from.discount
    return to
  }
  const replyCart = (l, r, c) => setTimeout(() => _replyCart(l, r, c), 1111)
  const _replyCart = (local, remote, callback) => {
    const localCart = JSON.parse(local?.json || '[]')
    const remoteCart = JSON.parse(remote?.json || '[]')
    console.log({tcp: 3, local, remote, localCart, remoteCart})
    if (localCart.length && remoteCart.length) {
      if (equal(cleanCart(copy(localCart)), cleanCart(copy(remoteCart)))) return callback(confirmCart(remote))
      if (owner) {
        const cart = cartMerge({json: remote.json, reset: true})
        local.json = JSON.stringify(cart)
        const purchase = copyTotal(remote, local)
        return callback(confirmCart(purchase))
      }
      if (from.confirm) return callback(local)
      Toast({
        content: [`${vendorI} ${cartI} different than your ${cartI} ?`],
        response: [ 'Accept' , 'Discard' ],
        callback: r => {
          if (r) {
            const cart = cartMerge({json: remote.json, reset: true})
            local.json = JSON.stringify(cart)
            callback(confirmCart(copyTotal(remote, local)))
          } else callback(confirmCart(local))
        }
      })
    }
    else if (remoteCart.length) callback(confirmCart(remote))
    else if (localCart.length) callback(confirmCart(local))
    else callback(Chat[pid]?.offline && Chat[pid]?.auto ? confirmCart(remote) : remote)
  }
  switch (r.type) {
    case 'init':
    if (r.response) {
      console.log(ID, `IO.init cache(time)=${cache('time')} r.response.time=${r.response.time}`)
      // if (cache(_.TIME) !== r.response.time) { // new bundule
      //   sessionStorage.clear()
      //   localStorage.clear() // also clears cookies ?
      //   console.log('IO dispatch cache session clean', IO.store, IO.socket, IO.history, prop)
      //   cache(_.TIME, r.response.time)
      //   // setTime(()=>IO.Table[`${_.VIEW}${_.MASTER}`].setState({toggle: }))
      //   // setTimeout(()=>window.location.reload(), 777)
      // }
      // act(action.io(IO.socket.connected, _.TIME))
      cache(`init${r.lang}`, r)
      // cache('init', true)
      localhost(r)
    }
    break

    case 'error':debugger; break
    case 'info':
    break

    case 'io':
    switch (r.io) {
      case 'cart':
      console.log({ [ID]: r.io, r, pid, ppk, fid, user, localPurchase, remotePurchase, park})
      // action.cart({localPurchase, remotePurchase, callback: () => {
        replyCart(localPurchase, remotePurchase, purchase => {
          console.log({purchase})
          const cart = cartMerge({json: purchase.json, reset: true})
          purchase.json = JSON.stringify(cart)
          if (!owner && user[pid].lock!==lock) {Toast({response: [okI], content: [`${storeI} ${lock ? lockI : openI} ${orderI} `]});debugger}
          setTimeout(() => Ref.store.dispatch(action.user(pid, { ...user[pid], stale: purchase.modified, purchase, lock })), 1)
          setTimeout(() => setPark({buffer: {[cookie.p]: {purchase: {[pid]: {default: {[ppk]: purchase}}}}}}), 111)
        })
        if (r.data.chat) {
          setTimeout(() => dispatch({ ...r, io: 'chat'}), 1111)
        }
      // }
      // })
      // replyCart(localPurchase, remotePurchase, purchase => {
      //   console.log({purchase})
      //   const cart = cartMerge({json: purchase.json, reset: true})
      //   purchase.json = JSON.stringify(cart)
      //   if (!owner && user[pid].lock!==lock) {Toast({response: [okI], content: [`${storeI} ${lock ? lockI : openI} ${orderI} `]});debugger}
      //   setTimeout(() => IO.dispatch(action.user(pid, {...user[pid], stale: purchase.modified, purchase, lock})), 1)
      //   setTimeout(() => setPark({buffer: {[cookie.p]: {purchase: {[pid]: {default: {[ppk]: purchase}}}}}}), 111)
      // })
      // if (r.data.chat) {
      //   r.io = 'chat'
      //   setTimeout(() => dispatch(r), 1111)
      // }
      break

      case 'stage':
      if (owner) remotePurchase.id = pid
      Object.keys(user).reduce((accUser, id) => {
        if (owner && !isNaN(id)) return accUser
        const stageU = owner && Ref.stage[id].state.stage
        if (owner && !(from.stage.name==stageU.name && from.stage.pin==stageU.pin)) return accUser // no response, incorrect name, pin
if (owner && user[from.stage.pk]?.p) debugger
        const purchase = copy(park.purchase[owner ? id : vid].default[owner ? id : npk])
        const buff = {
          type: 'io',
          io: 'purchase',
          data: {purchase},
          from: {
            id: cid,
            pk: owner ? id : npk,
            stage: owner ? stageU : from.stage,
            p: cookie.p,
          },
          to: [owner ? fid : vid],
          p: from.p,
        }
        const su = {...user[fid], p: from.p, purchase, lock}
        if (owner) {
          purchase.customer = fid // from.id
          purchase.id = fpk // from.pk
          // setTimeout(() => IO.dispatch(action.user(id)))
          su.title = from.stage.name
          su.stage = stageU
          setTimeout(() => dispatch({buffer: {[cookie.p]: {purchase: {[id]: {default: {[id]: purchase}}}}}}), 1)
        } else {
          delete(su.q)
          su.stage = from.stage
          setTimeout(() => dispatch({buffer: {[cookie.p]: {purchase: {[pid]: {default: {[ppk]: purchase}}}}}}), 1)
        }
        setTimeout(() => Ref.store.dispatch(action.user(fid)), 1)
        // setTimeout(() => Ref.store.dispatch(action.user(owner ? id : pid, su)), 1)
        setTimeout(() => Ref.store.dispatch(action.user(owner ? id : pid, su)), 1)
        console.log({ID, id, fid, from, buff, purchase}, user[id])
        tcp(buff, buff.p)
      }, [])
      break

      case 'online':
      if (fid==cid && !r[`p${vid}`]) {// store disconnected between online check and go online
        Ref.socket.disconnect()
        return Toast({response: [master.ok.i], content: ['Vendor offline'], callback: r => {
          if (r) window.location.reload()
        }})
      }
      if (from.p && isNaN(pid) && !isNaN(fid) && (!user[pid] || !equal(from.stage, user[pid].stage))) {
        // return tcp({debug: ID, type: 'io', io: 'find', p: from.p, to: [fid], data: pid}, from.p)
        return tcp({type: 'io', io: 'find', p: from.p, to: [fid], data: pid}, from.p)
      }
      replyCart(localPurchase, remotePurchase, purchase => {
        console.log({purchase, from, pid})
        if (owner) purchase.id = pid
        Ref.store.dispatch(action.user(pid, {...from, stale: purchase.modified, purchase, lock}))
        setPark({ buffer: { [ cookie.p ]: { purchase: { [ pid ]: { default: { [ ppk ]: purchase }}}}}}, () => {
          var key = `${ pid } purchase default ${ ppk }`
          promise(({ park }) => {
            if (!Row[key]) return true
            Row[key].rowClick(pid, 'purchase', ppk, false, false)
            eId(`user${pid}`).classList.add('clear')
          })
        })
        if (!mute && visible) audio('user')
      })
      break

      case 'purchase':
      // return setPurchase(r)

      if (!owner && !localPurchase && isNaN(pid)) {
        const _purchase = park.purchase[vid].default[npk]
        _purchase.id = pid
        const purchaseRow = { buffer: { [ cookie.p ]: { purchase: { [pid]: { default: { [ppk]: _purchase }}}}}}
        // setTimeout(() =>
          setPark(purchaseRow)
          // setPurchase({buffer: {[cookie.p]: {purchase: {[pid]: {default: {[ppk]: _purchase}}}}}})
        // , 1)
        promise(({ park }) => {
          if (!park.purchase?.[pid]) return true
          // setTimeout(() =>
            dispatch(r)
            // setPurchase(purchaseRow)
          // , 111)
        })
        return
      }

      // setPurchase(localPurchase, remotePurchase)

      replyCart(localPurchase, remotePurchase, purchase => {
        console.log({purchase})
        var _lock = user[pid]?.lock
        if (isNaN(pid) && !user[pid] && user[fid].id==vid) {
          console.log({pid, fid, vid}, user[fid])
          const {q, ...pu} = user[fid]
          _lock = pu.lock
          setTimeout(() => Ref.store.dispatch(action.user(fid)), 1)
          setTimeout(() => Ref.store.dispatch(action.user(pid, {...pu, p: from.p, stale: purchase.modified, purchase, stage: from.stage, lock})), 1)
        } else setTimeout(() => Ref.store.dispatch(action.user(pid, {...user[pid], stale: purchase.modified, purchase, lock})), 1)
        setTimeout(() => setPark({buffer: {[cookie.p]: {purchase: {[pid]: {default: {[ppk]: purchase}}}}}}), 11)
        var key = `${ pid } purchase default ${ ppk }`
        promise(({ user }) => {
          if (!user[pid]) {debugger;return true}
          // if (!owner && user[pid].lock!==lock) Toast({response: [okI], content: [`${storeI} ${lock ? lockI : openI} ${orderI}`]})
          if (!owner && _lock!==lock) Toast({response: [okI], content: [`${storeI} ${lock ? lockI : openI} ${orderI}`]})
          setTimeout(()=> {
            console.log(ID, purchase, { Row: Row[key], pid, ppk, fid, fpk, r, Row, park })
            Row[key].rowClick(pid, 'purchase', ppk, false, false)
  if (!fromVendor && !eId(`user${pid}purchase`)) debugger
            if (fromVendor) {
              if (from.stage.pk) {
                setTimeout(() => {
                  console.log(ID, copy(Ref.stage))
                  // const timerId = Ref.stage[fid].state.timerId
                  const timerId = Ref.stage[pid].state.timerId
                  if (timerId) clearInterval(timerId)
                  Ref.stage[pid].setState({ stage: from.stage, init: from.stage, wait: '', edit: false, timerId: null, staging: false })
                }, 333)
              }
            }
            // if (cart.length) eId(`user${pid}purchase`).classList.add('clear')
            if (purchase.json != '[]') eId(`user${pid}purchase`)?.classList?.add('clear')
            console.log({ID, pid, fid, tid})
            if (!mute && visible) audio('cart')
          }, 222)
        })
      })
      break

      case 'logout':
      case 'init':
      Ref.socket.close()
      if (!mute && visible) audio('user')
      Toast({response: [master.ok.i], content: ['Store open on new device.'], callback: r => {
        if (r) window.location.reload()
      }})
      break

      case 'chat':
      console.log({ID, r, fid, fpk, data, mute, Chat})
      const eChat = eId(`user${pid}chat`)
      if (!(eChat && Chat[pid])) break
      Chat[pid].setChat(data.chat)
// if (!(eChat.checkVisibility() && isElementVisible(eChat))) debugger
console.log({eChat, Chat, checkVisibility: eChat.checkVisibility(), isElementVisible: isElementVisible(eChat)})
      // if (!(eChat.checkVisibility() && isElementVisible(eChat))) eChat.classList.add('clear')
      eChat.classList.add('clear')
      // if (!mute && visible) audio('chat')
      if (!mute) audio('chat')
      break

      case 'find':
      if (!mute && visible) audio('user')
      return Toast({response: [master.ok.i], content: ['Order not found. Either delivered or canceled. Start new order'], callback: r => {
        if (r) {
          deleteBlank(vid, 'purchase', prop)
          stage(vid)
        }
      }})
      break

      case 'offline':
      switch (data) {
        case 'offline':
        display = [title || name, master.offline.i]
        break
        case 'force':
        display = [title || name, master.force.i, master.offline.i]
        break
        case 'block':
        session(`${fid}block`, tid)
        display = [title || name, master.block.i, master.offline.i]
        break
      }
if (tid==fid) {debugger
  goOffline(prop, tcp, tact)
  Ref.socket.disconnect()
}
      if (fromVendor) {
        Toast({response: [master.ok.i], content: display})
        Ref.socket.disconnect()
        Ref.store.dispatch(action.user())
      } else {
        const found = Object.keys(user).reduce((acc, id) => {
          const _fid = user[id].from?.id || user[id].id
          if (_fid==fid) return id
          if (from.stage && from.stage.pk && from.stage.pk==id) {debugger;return id}
          return acc
        }, false)
        if (found) {
          if (user[found].stage && user[found].stage.pk) {
            delete(user[found].p)
            Ref.store.dispatch(action.user(found, user[found]))
          } else Ref.store.dispatch(action.user(found))
        } else Ref.store.dispatch(action.user(fid))
      }
      if (!mute && visible) audio('user')
      Ref.status.setState({init: false})
    }
    break

    case 'user':
    const _u = {
      id: r.id,
      p: r.p,
      pk: npk,
      lock: vendorCache?.lock || false,
      type: user[r.id]?.type || 'customer',
      title: master.new.i,
      modified: 0,
      rate: _.RATE_M,
      count: 0, // purchase count
      stage: {},
    }
    // _u.type = user[_u.id] ? user[_u.id].type : 'customer'
    // _u.title = master.new.i
    // _u.modified = 0
    // _u.rate = _.RATE_M
    // _u.count = 0 // purchase count
    // _u.stage = {}
    cfgRow = getConfig(park, lang, r.id)
if (park.purchase[_u.id]?.[`vendor=${vid}`]) debugger
if (park.purchase[_u.id]?.[`from=${vid}`]) debugger
    if (cfgRow) {
if (!cookie.home) debugger
      _u.home = cookie.home
      _u.count = park.purchase[_u.id]?.[`vendor=${vid}`]?.length || 0
      _u.count = park.purchase[_u.id]?.[`from=${vid}`]?.length || 0
      _u.name = cfgRow.title
      _u.rate = cfgRow.rate
      _u.modified = cfgRow.modified
    }
    _u.media = image(park, _u, cfgRow)
    if (vendorCache?.stage?.pk) _u.stage = vendorCache.stage
    // no break
    // case 'vendor': // never called by sio
    const _v = {
      id: vid,
      pk: npk,
      lock: vendorCache?.lock || false,
    }
    const pvid = p[`p${vid}`]
    if (pvid) {
      if (r.type=='user') {
        io = {
          // debug: ID,
          type: 'io',
          io: 'online',
          data: {purchase: localPurchase},
          p: pvid,
          to: [vid],
          from: _u,
          vid,
          lang,
          // shard: pvid,
          stale: localPurchase.modified,
        }
        // if (!owner) tcp(io, pvid)
        if (!owner) tcp(io)
      }
      _v.p = pvid
    }
    if (login && !owner) _v.count = park.purchase[vid][_.PUB]
    cfgRow = getConfig(park, lang, vid)
    _v.title = cfgRow.title
    _v.rate = cfgRow.rate
    _v.modified = cfgRow.modified
    _v.home = vendor.home
    _v.media = image(park, _v, cfgRow)
    _v.type = 'vendor'
    _v.stage = {}
if (park.purchase[_v.id][`customer=${_u.id}`]) debugger
    _v.count = park.purchase[_v.id][`customer=${_u.id}`]?.length || 0
    if (pvid && !vendorCache?.title && (_u.id != vid)) {
if (!localPurchase) debugger
      Ref.store.dispatch(action.user(vid, _v)) // no self park
      setTimeout(() => {
        dispatch({[cookie.p]: {buffer: {[cookie.p]: {purchase: {[vid]: {default: {[npk]: localPurchase}}}}}}})
        setTimeout(() => {
          var key = `${ vid } purchase default ${ npk }`
          promise(() => {
            const tip = Field[ `${ key } tip` ]
            if (!tip) return true
            if (localPurchase.tip != tip.state.value) tip.setField({ value: localPurchase.tip, stale: neverStale })
            const discount = Field[ `${ key } discount` ]
            if (localPurchase.discount != discount.state.value) discount.setField({ value: localPurchase.discount, stale: neverStale })
          })
        }, 111)
      }, 1)
    }
    break

    case 'error':
    case 'e':
    debugger
    break

    default: // response
    if (r['description']=='not found') { // accomodate link preview response
      console.log({ID, IO: 'not found', ...r})
      debugger
      go(Ref.history.replace, ['master', `error?lang=${lang}&ref=${r.title}`])
      break
    }
    // if (typeof r=='string') {const a=`#${_.STATE}`;document.write(r); debugger; break}
    if (typeof r=='string') {
      const a = '#state'
//         const iframe = document.createElement('iframe')
//         // iframe.innerHTML = r
//         iframe.srcdoc = r
//         document.body.prepend(iframe);
// debugger
//         const title = iframe.querySelector("[name~=title][content]")
//         const desc = iframe.querySelector("[name~=description][content]")
//         const image = iframe.querySelector("[name~=image][content]")
//         const url = iframe.querySelector("[name~=url][content]")
//         const type = iframe.querySelector("[name~=type][content]")
      // document.body.innerHTML=r
      console.log(ID, `IO preview ${r}`);
      break
    }
    const u = r.u || 'store'
    Object.keys(r.buffer || {}).reduce((hosts, host) => {
      Object.keys(r.buffer[host]).reduce((vs, v) => {
        const vLogin = v == 'login'
  if (!v)debugger
        Object.keys(r.buffer[host][v]).reduce((dbs, db) => {
  if (!db)debugger
          if (db=='find') return dbs
          const store = r.buffer[host][v][db]
          if (_.VERB_.includes(db)) { //printer
            cache(`${lang}${v}${db}`, store)
            return dbs
          }
          switch (v) {
            case 'suggest':
            case 'recommend':
            case 'error':
            case 'cart':
            cache(`${lang}${v}${db}`, store)
            return dbs
          }
          const offset = store.offset || 0
          const print = store.print || _.PUB
          const meta = `${offset}${print}`
          const modified = store.modified
          const where = store.where
          const count = store.count
          const album = store.album
          const all = store.all
          const vkey = `${lang}${db}${v}`
          const vcache = cache(vkey) || {}
          var need
          if (modified) {
            if (!vcache.modified) vcache.modified = modified
            else if (vcache.modified != modified) {
              // cache(vkey, null)
              console.log(ID, `IO Modified tcp vcache, need more work`, {db, v, vcache})
              // cache(vkey, null)
              // return dbs
              // if (!IO.Modified[db])    IO.Modified[db] = {}
              // if (!IO.Modified[db][v]) IO.Modified[db][v] = {}
              // IO.Modified[db][v].modified = store.modified
              vcache.modified = modified
              // IO.Task.push({callback: IO.Table[db][v].setTable, arg: [{collapse: true, init: false}], delay: 1})
              // if (u=='store' && v==_.CONFIG) IO.Task.push({callback: IO.Table[db][v].setTable, arg: [{collapse: false, init: false}], delay: 1})
            }
          }
          if (store.verify) {
            console.log({[ID]: 'needs work on VERIFY'})
          //   Object.keys(store.verify).forEach(pk => {
          //     const row = cache(`${lang}${db}${v}${pk}`)
          //     if (!row.modified!=store.verify[pk]) {
          //       if (!IO.Modified[db])              IO.Modified[db] = {}
          //       if (!IO.Modified[db][v])           IO.Modified[db][v] = {}
          //       if (!IO.Modified[db][v].verify) IO.Modified[db][v].verify = {}
          //       IO.Modified[db][v].verify[pk] = store.verify[pk]
          //     }
          //   })
          }
          if (store[meta]) vcache[meta] = store[meta].map(m => Number(m))
          if (store[print]) vcache[print] = Number(store[print])
          if (store[where]) {
            vcache[where]=store[where]
            if (where=='valid') {
              need = store[where]
              vcache[need] = store[need]
            }
          }
          if (album) {
            need = `\`album\`='${album}'`
            vcache[need] = store[need]
            vcache[album] = store[album]
          }
          if (store[count]) vcache[count] = Number(store[count])
  if (store[all]) {debugger}
          cache(vkey, vcache)
          const rv = r.v
          const rpk = r.pk
          const rverb = r.verb
          Object.keys(store).reduce((verbs, verb) => {
            // const rows = store[verb] || {}
            const bulk = store.bulk
            if (verb=='e') {
              var verbose='';
              const reload = store[verb] == 'login'
              switch (store[verb]) {
                case 'login': verbose = 'session expired.'
                default:
                Toast({response: ['Ok'], content: [`Error ${store[verb]} ${verbose ? ', ' + verbose: ''}`], callback: r => {
                  if (reload) window.location.reload()
                }})
              }
            }
            if (!bulk && !_.VERB_.includes(verb)) return verbs
            if (verb=='otp') {
              session('otp', store[verb].username)
              return go(Ref.history.push, ['master', 'otp'], [`lang=${lang}`])
            }
            const rows = bulk ? {} : store[verb]
            Object.keys(rows).reduce((pks, pk) => {
              if (isNaN(pk) || pk <= 0) return pks
              const row = rows[pk]
if (!row)debugger
              if (row.e) {console.log(ID, row.e);debugger}
              switch (verb) {
                case 'reset':
                Toast({response: [master.ok.i], content: [`${master[verb].i} ${master.success.i}`], callback: r => {
                  setTimeout(() => {
                    go(Ref.history.replace, ['master', `profile?lang=${lang}`])
                    // setTimeout(() => {
                    //   window.location.reload()
                    // }, 1111)
                  }, 1111)
                }})
                break
                case 'e':debugger
                if (!r.buffer[host][v][db][rverb])  r.buffer[host][v][db][rverb] = {}
                r.buffer[host][v][db][rverb][rpk] = row
                break
                case 'insert':
                if (v=='notice') break
                // no break
                case 'update':
                const clone = r.pk > 0 && verb=='insert'
                if (Array.isArray(row) && row.length==2) {
                  var [status, last_insert_id] = row
                  npk = Number(last_insert_id)// + Number(i)
                } else npk = r.pk
                // } else if (clone || verb=='update') npk = r.pk
                // const nrow = {id: npk, ...r.request}
                // if (v=='login') {
                //   delete(r.request.otp)
                //   delete(r.request.passwordcurrent)
                //   delete(r.request.passwordagain)
                // }
                const _nrow = {...park[rv][db].default[npk], ...r.request}
                const nrow = rv=='login' ? r.buffer[host][rv][db][verb][npk] : (verb=='insert' ? r.request : _nrow)
                if (!r.buffer[host][rv][db].default) r.buffer[host][rv][db].default = {} // r.buffer[host][login][db].update, r.buffer[host][login][db].reset
                r.buffer[host][rv][db].default[npk]=nrow
                rows[npk] = nrow
                // if (clone) lang = nrow.lang
                // cache(`${lang}${db}${v}`, null)
                cache(`${clone ? nrow.lang : lang}${db}${v}`, null)
                // npk = verb=='insert' ? prop.new[db][v] : r.pk
                npk = clone || verb=='update' ? r.pk : prop.new[db][v]
                // setTimeout(() => {
                //   Object.keys(Fields[db][v][npk][verb]).forEach(id => {
                //     Fields[db][v][npk][verb][id][''].init()
                //   })
                // }, 1111)
                Ref.row[db][v][npk].setRow({stale: false})
                if (clone) {debugger
                  // IO.viewmaster.setWakeup({meta: {db, v, npk}, wakeup: {[v]: {[db]: {[pk]: 'find'}}}})
                }
                promise(() => {
                  const el = eId(`${db}${v}${pk}`)
                  console.log(ID, 'tcp', {el, db, v, pk, npk})
                  if (!el) return true
                  // setTimeout(()=> el.scrollIntoView(false), 111)
                  // if (!clone) deleteBlank(db, v, prop)
                  if (verb=='insert') deleteBlank(db, v, prop)
                  else {
                    var key = `${ db } ${ v } ${ verb } ${ npk }`
                    Object.keys(r.request).forEach(id => {
                      // const field = Fields[db][v][npk][verb][id]['']
                      const field = Field[ `${key} ${ id }` ]
                      console.log({Ref, field})
                      const password = id.includes('password')
                      const otp = id.includes('otp')
                      if (field) field.init({ value: password || otp ? '' : r.request[id] })
  if (!field) debugger
                    })
                    toast(`${ master[verb].i } ${ master.success.i }`)
                  }
                })
                break
                case 'delete':
// if (pk<0 || vLogin) debugger
if (pk<0) debugger
                if (pk<0) deleteBlank(db, v, prop)
                // case 'default': debugger
              }
              return pks
            }, {})
            if (bulk) {
              var [ status, last_insert_id ] = bulk
              last_insert_id = Number(last_insert_id)
              status = Number(status)
              for (var i = 0; i < status; i++) {
                npk = last_insert_id - status + 1 + i
                const nrow = {
                  id: npk,
                  modified: r.request.modified,
                  title: r.request.selectmedia[i].title,
                  type: r.request.selectmedia[i].type,
                  uri: r.request.selectmedia[i].uri,
                }
                r.buffer[host][rv][db].default[npk] = nrow
                rows[npk] = nrow
              }
              cache(`${ lang }${ db }${ v }`, null)
              deleteBlank(db, v, prop)
            }
            Object.keys(rows).reduce((pks, pk) => {
              // if (isNaN(pk)) debugger
              if (isNaN(pk) || pk <= 0) return pks
              const row = rows[pk]
              switch (verb) {
                case 'default':
                const find = row && (typeof row=='object' || row=='find')
                const isArray = find && Array.isArray(row) ? '[]' : ''
                var key = vLogin ? `${pk}${isArray}` : `${lang}${db}${v}${pk}${isArray}`
                if (find) {
                  if (row!='find') {
                    if (vLogin) {
                      const loginRow = getLoginRow(row)
                      console.log(Ref)
                      if (row.length<9) {
                        cache(pk, loginRow)
                        cache(key, row) // middle vendor[]
                        cache(loginRow.username, pk)
                      } else {
                        session(pk, loginRow) // master.view login
                        session(key, row) // master.view login
                        session(loginRow.username, pk) // action delete
                        if (__DEV__) {
                          const policy = `path=/;SameSite=Strict;`
                          document.cookie = `login=${Math.floor(Date.now()/1000)};${policy}`
                          document.cookie = `id=${pk};${policy}`
                          document.cookie = `username=${row[3]};${policy}`
                          document.cookie = `home=${row[2]};${policy}`
                          document.cookie = `name=${row[5]};${policy}`
                          console.log({[ID]: 'dispatch', row, cookie: document.cookie})
                        }
                      }
                    } else cache(key, row)
                  }
                }
                break
              }
              return pks
            }, {}) // rows
            return verbs
          }, {}) // verbs
          return dbs
        }, {}) // dbs
        return vs
      }, {}) // vs
      return hosts
    }, {}) // hosts
    // if (type==_.P) setTimeout(() => IO.dispatch(action[`${_.PART}${_.RESPONSE}`](r)), 1)
    // switch(type) {
      // case _.P:
      // // r = IO.cachePrinter(r)
      // setTimeout(() => IO.dispatch(action[`${_.PART}${_.RESPONSE}`](r)), 1)
      // break

      // case _.E: debugger// unrecoverable error
      // console.log(`IO E /${lang}/${_.MASTER}/${_.PART_[_.ERROR]}?${_.REF}=${_.PART_[r[u].e]}`)
      // setTimeout(() => IO.history.replace(`/${lang}/${_.MASTER}/${_.PART_[_.ERROR]}?${_.REF}=${_.PART_[r[u].e]}`), 1)
      // break

      // case _.U: // also recoverable error
      // console.log(`IO dispatch request r`, r)
      // setTimeout(() => IO.dispatch(action.requestresponse(r)), 1)
    // }
    setP(r)
    setPark(r, callback)
    // setP(r, () => setPark(r, callback))
    if (Object.keys({ ...Ref[ID].Modified }).length) console.log({ID, 'IO.Modified tcp': Ref[ID].Modified})
    if (r.HOST) {
      delete(Ref[ID].Net?.[r.HOST])
      console.log({ID, 'Ref.Modified tcp r.HOST': r.HOST, 'Ref.Net': Ref[ID].Net, 'tariq': Ref.row}, Ref, 'tariq')
    }
  } // switch (r.type)
}
var serverLogin = false
const deleteBlank = (db, v, prop) => {
  const blank = copy(prop.new)
  // if (blank[db]?.[v])
  delete(blank[db][v])
  // setTimeout(()=> {
    setBlank(blank)
    tact('new', [blank])
  // }, 1111)
}
export const uuidv4 = () => ("10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)))
var __PK__ = 0
const Pk = () => --__PK__
export const newRow = (prop, db, v) => {
  const {verb, uid, lang, vid, vendor, route, u, views, login, owner} = prop.master
  const park = prop.park
  const printer = park[v][verb]
if (!printer)debugger
  // const pk = Pk()
  const pk = v=='login' ? uid : Pk()
  // console.log(Object.keys(printer[_.VIEW][_.FIELD]).map(f=>printer[_.VIEW][_.FIELD][f]))
  // console.log(Object.keys(printer[_.VIEW][_.FIELD]))
  const modified = Math.floor(Date.now()/1000)
  const row = Object.keys(printer.view.field).reduce((fs, f, i) => {
    // if (f==JSONDELIVER)debugger
   if (f==v || !printer.view.field[f]) return fs
    switch (f) {
      // case v: return fs
      // case JSONDELIVER:// JSON.stringify(fs.push(..._.JSONDELIVER_)); break
      // debugger
      case 'map': fs.push(JSON.stringify(initialGeoCode)); break
      // fs.push(printer[_.PART][f]['v']['input']['value'])
      // break
      case 'jsondeliver':// JSON.stringify(fs.push(..._.JSONDELIVER_)); break
      case 'selectmedia':
      case 'items':
      case 'medias':
      case 'reviews':
      case 'json': //case `${_.JSON}${_.CART}`: case `${_.JSON}${_.DELIVER}`:
//      debugger
      fs.push('[]')
      break
      case 'from':
      case 'customer':
      fs.push(uid)
      break
      // case _.TO:
      case 'vendor':   fs.push(vid || ''); break
      case 'id':       fs.push(pk); break
      case 'rate':     fs.push(_.RATE_M); break
      case 'expire':   fs.push(0); break
      case 'modified': fs.push(modified); break
      case 'lang':     fs.push(lang); break
      case 'print':   fs.push(1); break
      case 'ref':      fs.push(uuidv4()); break
      // case _.TYPE:     fs.push(1); break
      default:         fs.push('')
    }
    // console.log({f, i})
    return fs
  }, [])
  if (row.length==0) row.push(pk)
  if (!Blank[db]) Blank[db] = {}
  Blank[db][v]=pk
  var _row = row
  // if (v=='login') _row = [pk, modified, '', '', '', '', '', '', '', '', '', '', '[]', '']
  if (v=='login') _row = [pk, modified, '', '', '', '', '', '']
  // if (v=='login') _row = [pk, modified, '', '']
  setTimeout(() => {
    if (v=='purchase' && STAGE[vid]) {
      // _row = STAGE[vid].purchase
      _row = Object.keys(STAGE).reduce((acc, id) => {
        if (STAGE[id].id==vid) return STAGE[id].purchase
        return acc
      }, row)
  }
    // if (v==_.PURCHASE) {
    //   const sess = session(v) || {}
    //   // if (sess[vid] && sess[vid].now > Date.now()) {
    //   if (sess[vid]) {
    //     sess[vid].row[_.ID] = pk
    //     _row = sess[vid].row
    //   }
    // }
    dispatch({verb, buffer: {[cookie.p]: {[v]: {[db]: {default: {[pk]: _row}}}}}})
    prop.action.new(copy(Blank))
    // if (v==_.PURCHASE) {
    //   const cartCount = copy(prop.master.cartCount)
    //   cartCount[db] = ''
    //   prop.setMaster({cartCount})
    // }
    console.log({[ID]: 'New', db, v, pk, _row, Blank})
    // debugger
  }, 1)
  return pk
}
// Ref.setBlank = setBlank
// Ref.getBlank = getBlank
// Ref.newRow = newRow
const IO_Module = {
  ID,
  tcp,
  tcp2,
  network,
  setPurchase,
  setP,
  setPark,
  localhost,
  act,
  tact,
  loop,
  go,
  cartMerge,
  dispatch,
  newRow,
  uuidv4,
}

export default IO_Module
